/*
 * File: /src/services/referralServices.js
 * Created Date: Sunday June 6th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 6th June 2021 8:43:06 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_RESERVATIONS_PATH } from '../constants';

export default {
  /**
   * Fetch Reservations
   * @param {number} after_id
   * @param {number} limit
   * @param {number} filter
   * @param {number} sort
   * @returns ReservationPage
   */
  fetchReservations(after_id, limit, filter, sort) {
    const params = {
      limit: limit ? limit : 100,
      filter: filter,
      sort: sort,
    };
    if (after_id) {
      params.after_id = after_id;
    }
    return authedAxios
      .get(AD_BASE_RESERVATIONS_PATH, {
        params: params,
      })
      .then((r) => r.data);
  },

  /**
   *
   *
   * @returns
   */
  fetchReservationCount() {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'count');
  },

  /**
   * Fetch Reservation by Id
   */
  fetchReservationsById(id) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + id);
  },

  /**
   * Fetch Reservation by Contact Id
   */
  fetchReservationsByCustomerId(id) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'contact/' + id);
  },

  /**
   * Fetch Reservation Types
   */
  fetchReservationTypes() {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'reservation-types');
  },

  fetchGapNights(days) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'gap-night',
    {
      daysInFuture: days,
    });
  },
  latestByContactId(contactId) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'contact/' + contactId + '/latest');
  },

};
